import React, {useMemo, useState} from 'react'
import './mappings.css'
import Tabs from './Subcomponents/Tabs'
import { enabledMappingTabs } from './Subcomponents/mappingTabs'
import ShippingMapping from './Subcomponents/ShippingMapping/ShippingMapping'
import PaymentMapping from './Subcomponents/PaymentMapping/PaymentMapping'
import MultiLocationMapping from './Subcomponents/MultiLocationMapping/MultiLocationMapping'
import ProductAttributeMapping from './Subcomponents/ProductAttributeMapping/ProductAttributeMapping'
import CustomerAttributeMapping from './Subcomponents/CustomerAttributeMapping/CustomerAttributeMapping'
import SalesPersonMapping from './Subcomponents/SalesPersonMapping/SalesPersonMapping'

const Mappings = (props) => {
    const tabs = useMemo(() => enabledMappingTabs(props.instance), [props.instance])
    // Open on the first tab this connector has, which is also the one Tabs highlights.
    const [tabType, setTabType] = useState(tabs[0] ? tabs[0].key : null)

    const activeTab = (selectedTab) =>{
        setTabType(selectedTab)
    }
    
    return (
        <>
            <Tabs
                getActiveTab={activeTab}
                activeTab={tabType}
                instance={props.instance}
            />
            <div className='col-md-9 col-xl-9'>
                <div className='card mndesc'>
                    {
                        tabType == "ShippingMapping" ? 
                            <ShippingMapping
                                connectorId={props.connectorId}
                                instancesId={props.instancesId}
                            />
                        :
                        tabType == "PaymentMethod" ? 
                            <PaymentMapping 
                                connectorId={props.connectorId}
                                instancesId={props.instancesId}
                            />
                        :  
                        tabType == "MultiLocation" ? 
                            <MultiLocationMapping
                                connectorId={props.connectorId}
                                instancesId={props.instancesId}
                                targetId={props.targetId}
                            />
                        :
                        tabType == "ProductAttributeMapping" ?
                            <ProductAttributeMapping
                                connectorId={props.connectorId}
                                instancesId={props.instancesId}
                                sourceId={props.sourceId}
                                targetId={props.targetId}
                                sourceEndpointId={props.sourceEndpointId}
                                targetEndpointId={props.targetEndpointId}
                                id={props.id}
                                sourceShortName={props.sourceShortName}
                                targetShortName={props.targetShortName}
                            />
                        :tabType == "CustomerAttributeMapping" ?
                            <CustomerAttributeMapping
                                connectorId={props.connectorId}
                                instancesId={props.instancesId}
                                sourceId={props.sourceId}
                                targetId={props.targetId}
                                sourceEndpointId={props.sourceEndpointId}
                                targetEndpointId={props.targetEndpointId}
                                id={props.id}
                                sourceShortName={props.sourceShortName}
                                targetShortName={props.targetShortName}
                            />
                        :tabType == "SalesPersonMapping" ?
                            <SalesPersonMapping
                                connectorId={props.connectorId}
                            />
                        :<p className="text-muted mb-0 p-3">No mapping types are enabled for this connector.</p>
                    }
                </div>
            </div>
        </>
    )
}

export default Mappings